export default __webpack_public_path__ + "static/media/custom_application.69d16709.svg";